export const isStrongPassword = (password: string): boolean => {
  if (password.length < 8) return false;

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const typesCount = [hasLetter, hasNumber, hasSpecial].filter(Boolean).length;

  return typesCount >= 2;
};

export const getStrongPasswordErrorMessage = (lang: string): string => {
  if (lang === 'en') {
    return 'Password must be at least 8 characters long and include at least two of the following: letters, numbers, or symbols.';
  }

  return '密码长度需至少 8 位，且至少包含字母、数字或符号中的两种。';
};


